/** Data invalidation only: no record payloads, DOM replacement or navigation. */
export const ERP_REFRESH_INTERVAL_MS = 5_000;
const listeners = new Set<() => void>();
let interval: ReturnType<typeof setInterval> | undefined;
let queued: ReturnType<typeof setTimeout> | undefined;

function visible() {
  return document.visibilityState === 'visible' && navigator.onLine;
}

/** A successful local write, focus or reconnect asks mounted readers to revalidate.
 * Coalesce bursts so a single return to the browser does not issue three loads. */
export function requestErpRefresh() {
  if (!listeners.size || queued !== undefined) return;
  queued = setTimeout(() => {
    queued = undefined;
    if (visible()) for (const listener of listeners) listener();
  }, 150);
}

export function subscribeErpRefresh(listener: () => void): () => void {
  listeners.add(listener);
  if (listeners.size === 1) {
    interval = setInterval(requestErpRefresh, ERP_REFRESH_INTERVAL_MS);
    window.addEventListener('focus', requestErpRefresh);
    window.addEventListener('online', requestErpRefresh);
    document.addEventListener('visibilitychange', requestErpRefresh);
  }
  return () => {
    listeners.delete(listener);
    if (listeners.size) return;
    clearInterval(interval);
    clearTimeout(queued);
    interval = queued = undefined;
    window.removeEventListener('focus', requestErpRefresh);
    window.removeEventListener('online', requestErpRefresh);
    document.removeEventListener('visibilitychange', requestErpRefresh);
  };
}
